import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FuelSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FuelSVG;
